
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { defineComponent, onMounted, ref, computed } from "vue";
import PersonalInfor from "@/components/customers/PersonalInfor.vue";
import LearningInfor from "@/components/customers/LearningInfor.vue";
import AdmissionProfile from "@/components/customers/AdmissionProfile.vue";
import AdmissionProcedures from "@/components/customers/AdmissionProcedures.vue";
import ScholarshipRegisterDrawer from "@/components/customers/ScholarshipRegisterDrawer.vue";
import ScholarshipApproveModal from "@/components/customers/ScholarshipApproveModal.vue";
import WidgetStaffLecturerChild from "@/components/widgets/lists/WidgetStaffLecturerChild.vue";
import WidgetAssignUserGroup from "@/components/widgets/lists/WidgetAssignUserGroup.vue";
import WidgetComment from "@/components/widgets/lists/WidgetComment.vue";
import WidgetAssign from "@/components/widgets/lists/WidgetAssign.vue";
import ModalDeleteAndReason from "@/components/modals/wizards/ModalDeleteAndReason.vue";
import ModalChooseMajor from "@/components/modals/wizards/ModalChooseMajor.vue";
import ModalRunAnalysis from "@/components/modals/wizards/ModalRunAnalysis.vue";
import ModalEditInput from "@/components/modals/wizards/ModalEditInput.vue";

import ModalChooseApplicants from "@/components/modals/wizards/ModalChooseApplicants.vue";


import axios from "@/axios-instance"
import moment from "moment"
import Permission from "@/core/config/Permission";
import { gradWarningsOf } from "@/core/helpers/gradCheck";
import { emitter } from "@/main";
import { useRoute, useRouter } from "vue-router";

import { PrebuiltIdDocumentModel } from "@/views/apps/prebuild/prebuilt-idDocument";

interface Form {
  id?: string
  status: any;
  fullName: string;
  gender: string;
  dateOfBirth: string;
  birthPlace: string;
  phone: string;
  idCard: string;
  email: string;
  contactAddress: string;
  contactProvinceId: string;
  contactDistrictId: string;
  contactWardId: string;
  prProvinceId: string;
  prDistrictId: string;
  prWardId: string;
  prAddress: string;
  class10ProvinceId: string;
  class10DistrictId: string;
  class10SchoolId: string;

  class11ProvinceId: string;
  class11DistrictId: string;
  class11SchoolId: string;

  class12ProvinceId: string;
  class12DistrictId: string;
  class12SchoolId: string;
  graduatedYear: string;
  priorityObject: string;
  priorityArea: string;
  priorityScore: number;
  highschoolGraduation: string;
  verifiedDate: string;
  orderNumber: string;
  studentcode: string;
  issynccrm?: any
  leadid?: any
  opportunityid?: any
  //Stage Opportunity trên SF, lần BE đọc được gần nhất (chỉ hiển thị)
  sfStage?: any
  sfStageAt?: any
}
interface DataAdmission {
  date: string;
  code: string;
  method: string;
  id: string;
  action: boolean;
  isActive: boolean;
  source: string;
  status: {
    label: string;
    state: string;
    value: string;
  },
  majors: [{
    name: string,
    priority: string,
  }]
  phase?: string
}
interface DataApplicant {
  createdAt: string;
  id: number;
  applicantId?: string;
  phase: number;
  profileCode: string;
  major: string;
  status: string;
  applicantStatus?: string;
  studentId: string;
  majorCode?: string;
  studentcode?: string;
  //Phương thức dạng SỐ: cần để biết hồ sơ LIÊN THÔNG (=9) đã trúng tuyển hay chưa
  //(khối bằng TC/CĐ ở tab Học tập ẩn nút "mở hồ sơ liên thông để sửa" khi đã trúng tuyển).
  idAdMethod?: number;
}

export default defineComponent({
  name: "customer-details",
  components: {
    PersonalInfor,
    LearningInfor,
    AdmissionProfile,
    AdmissionProcedures,
    ScholarshipRegisterDrawer,
    ScholarshipApproveModal,
    WidgetComment,
    WidgetAssignUserGroup,
    WidgetStaffLecturerChild,
    WidgetAssign,
    ModalDeleteAndReason,
    ModalChooseMajor,
    ModalChooseApplicants,
    ModalRunAnalysis,
    ModalEditInput,
  },
  data() {
    return {
      passwordStudent: "",
      passwordView: "password",
      isChangeStatus: false,
      isChangeStatusGraduated: false,
      isTabs3: false,
      activeTabKey: 'learning', //tab mặc định = Thông tin học tập (đặt trước, active sẵn — bỏ auto-jump gây nháy)
      isHighschool: false,
      submithighschoolGraduation: "",
      scholarshipList: [],
      //Stage Opportunity đọc lại tại chỗ (ưu tiên hơn giá trị đã lưu ở dataCustomer.sfStage)
      sfStageLoading: false,
      sfStageLive: "",
      sfStageAtLive: "",
    }
  },
  methods: {
    //Stage hiển thị: bản vừa đọc lại (nếu có) > bản lưu lần đồng bộ gần nhất
    sfStageText() {
      return this.sfStageLive || this.dataCustomer.sfStage || ""
    },
    sfStageTitle() {
      const at = this.sfStageAtLive || this.dataCustomer.sfStageAt
      return at ? `Đọc từ Salesforce lúc ${moment(at).format('HH:mm, DD/MM/YYYY')}` : 'Stage trên Salesforce'
    },
    //Đọc LIVE stage từ SF (chỉ đọc, không ghi gì lên Salesforce)
    async refreshSfStage() {
      if (this.sfStageLoading) return
      this.sfStageLoading = true
      try {
        const { data } = await axios.get(`/admission/student/${this.dataCustomer.id}/sfstage`)
        this.sfStageLive = data.sfStage || ""
        this.sfStageAtLive = data.sfStageAt || ""
        if (!data.sfStage && data.message) {
          Swal.fire({ text: data.message, icon: 'info', buttonsStyling: false, confirmButtonText: 'Đã hiểu', customClass: { confirmButton: 'btn btn-primary' } })
        }
      } catch (err: any) {
        const msg = (err && err.response && err.response.data && (err.response.data.errorMessage || err.response.data.message)) || 'Không đọc được stage từ Salesforce.'
        Swal.fire({ title: 'Đọc stage thất bại', text: msg, icon: 'error', buttonsStyling: false, confirmButtonText: 'Đã hiểu', customClass: { confirmButton: 'btn btn-primary' } })
      } finally {
        this.sfStageLoading = false
      }
    },
    //Cảnh báo tốt nghiệp (helper dùng chung với list/drawer) — method thay computed vì hybrid component (bẫy TS2339)
    gradWarningList() {
      return gradWarningsOf(this.dataCustomer)
    },
    //Click banner: mở tab Thông tin học tập rồi cuộn tới card Bảng điểm thi TN (id=grad-score-card ở LearningInfor)
    goGradScoreCard() {
      const tabEl = document.querySelector('a[href="#kt_customer_view_learning_infor"]') as HTMLElement
      tabEl?.click()
      setTimeout(() => {
        const card = document.getElementById('grad-score-card')
        if (card) {
          window.scrollTo({ top: card.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' })
        }
      }, 250)
    },
    addAdmissionProfile() {
      // "Thêm hồ sơ" = điều hướng sang TRANG Thêm hồ sơ (bỏ modal — logic form tập trung ở profileAdd/AddAdmissionsApplication)
      this.router.push(`/themhoso/${this.route.params.id}`)
    },
    addArticulationProfile() {
      // Guard: đã có hồ sơ LT thì không cho tạo thêm (phòng thủ ngoài v-if của nút)
      if ((this.dataAdmission as any[]).some((h: any) => h.idAdMethod == 9)) { return }
      // "Thêm hồ sơ liên thông" = trang riêng /themhosolienthong/:idStudent (form LTĐHCQ ở chế độ tạo)
      this.router.push(`/themhosolienthong/${this.route.params.id}`)
    },
    runAnalysis() {
      // ?. : handler có thể bị gọi từ instance đã unmount (listener cũ còn sót) → bỏ qua thay vì crash
      this.callFunctionModalRunAnalysis?.showModal()
     
    },
    runEditField(value) {
      this.crmField = value
      this.callFunctionEditField.showModal()
    },
    async funcEditCRM(value) {
      await axios.put(`/admission/student/${this.route.params.id}`, {[value.field]: value.value})
      .then(({ data }) => {
        this.dataCustomer[value.field] = value.value
      })
      .catch(({ response }) => {
      });
    },
    async callChooseMajor() {
      this.callFunctionModalChooseMajor.showModal()
    },
    async callChooseApplicant() {
      this.callFunctionModalChooseApplicants.showModal()
      // this.syncRow(this.$route?.id)
    },
    popupSyncRowComplete(data:any) {
      let text = 'Đã tạo mã sinh viên thành công'
      this.dataCustomer.studentcode = data.studentcode//data.updatedStudent?.studentcode // update đổi format 31/05/2024
      // let error = data.failedPush[0]?.error||{} as any
      
      // if(error.message) {
      //   text = error.message?.error?.message || 'Có lỗi xảy ra trong quá trịnh tạo mã sinh viên'
      // }
      // else {
      //   this.dataCustomer.studentcode = data.successPush[0]?.data?.studentcode
      // }
      Swal.fire({
          html: text,
          icon: 'success',
          buttonsStyling: false,
          confirmButtonText: "Đóng",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          }).then(() => {
            
            Swal.close()
          },300);
    },
    async syncRow(dataForm) {
        // console.log('sdasa',dataForm)
        // console.log('sdasa router',)
        let idStudent = this.route.params?.id
        // Swal.fire({
        //     text: `Bạn có muốn tạo mã sinh viên này trên SIS không?`,
        //     icon: "question",
        //     buttonsStyling: false,
        //     showCancelButton: true,
        //     confirmButtonText: "Đồng ý",
        //     cancelButtonText: "Trở lại",
        //     customClass: {
        //     confirmButton: "btn btn-primary order-2",
        //     cancelButton: "btn btn-light order-1",
        //     },
        // }).then(async (result) => {
        //     if(result.isConfirmed) {
            this.popupLoading()
              await axios.post(`/admission/create/customer/${idStudent}`,dataForm)
              .then(( {data} ) => {
                this.popupSyncRowComplete(data)
              })
              .catch(({ response }) => {
                  // if(response.data?.adMajors && response.data.adMajors.length != 0) {
                  //   Swal.close()
                  //   this.chooseMajor = response.data?.adMajors
                  //   this.callChooseMajor()
                  //   return
                  // }
                  // console.log('err',response)
                  Swal.fire({
                    html: response.data?.message||response.data?.errorMessage,
                    icon: 'error',
                    buttonsStyling: false,
                    confirmButtonText: "Đóng",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                    }).then(() => {
                      Swal.close()
                    },300);
                });
        //       }
           
        // });
        
    },
    togglePassword() {
      var password = (document.getElementById("textPassword") as HTMLInputElement);
      const type = password.getAttribute("type") === "password" ? "text" : "password";
      this.passwordView = type
      password.setAttribute("type", type);
    },
    renderPassword() {
      Swal.fire({
        title: 'Bạn có chắc không?',
        text: "Bạn sẽ không thể hoàn nguyên điều này!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Có, hãy tạo mới!',
        cancelButtonText: 'Hủy'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await axios.post(`/applicant/access/reset`, {
            idCard: this.dataCustomer.idCard,
            email: this.dataCustomer.email
          })
            .then(({ data }) => {
              if (data.status =="success") {
                Swal.fire({
                  title: "Reset mật khẩu thành công!",
                  html: `<strong class='fs-3'>${data.info.newAccessCode}</strong>`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Đóng",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then(() => {
                  Swal.close()
                });
                this.passwordStudent = data.info.newAccessCode
              }
            })
            .catch(({ response }) => {
            });
        }
      })
    },
    sendPasswordByMail() {
      Swal.fire({
        title: 'Bạn có chắc không?',
        text: "Bạn sẽ không thể hoàn nguyên điều này!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Gửi',
        cancelButtonText: 'Hủy'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await axios.post(`/applicant/access/sendmail`, {
          idCard: this.dataCustomer.idCard, 
          email: this.dataCustomer.email
          })
          .then(({ data }) => {
            if (data.status == "success"){
              Swal.fire({
                text: "Đã gửi email đến ứng viên thành công!",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                Swal.close()
              });
            }
          })
          .catch(({ response }) => {
          });
        }
      })
    },
    callModalDelete() {
      this.callFunctionModal?.showModal()
    },
    checkHighschoolGraduation(isCheck) {
      this.isHighschool = isCheck
    },
    // force=true: bỏ qua cảnh báo "xóa nhầm bản đang giữ hồ sơ" của backend (chỉ khi người dùng xác nhận)
    async isDeleteFunction(reason = undefined, force = false) {
      let data = {
        ids: [this.route.params.id],
        isDelete: true,
        reason: reason,
        force,
      };
      await axios.put(`/admission/student/update/ids`, data)
        .then(({ data }) => {
          this.router.push({ path: '/danhsachungvien' })
        })
        .catch(({ response }) => {
          // Backend cảnh báo đang xóa nhầm bản MANG hồ sơ (bản trùng còn lại rỗng) -> hỏi lại,
          // cho phép vẫn xóa nếu người dùng khẳng định. Xem guard DELETE_WOULD_LOSE_PROFILE ở BE.
          if (response?.data?.code === 'DELETE_WOULD_LOSE_PROFILE') {
            Swal.fire({
              title: "Khoan đã — có thể bạn đang xóa nhầm",
              html: `${response.data.message}`,
              icon: "warning",
              showCancelButton: true,
              buttonsStyling: false,
              confirmButtonText: "Tôi chắc chắn, vẫn xóa",
              cancelButtonText: "Để tôi kiểm tra lại",
              customClass: {
                confirmButton: "btn btn-danger order-2",
                cancelButton: "btn btn-light order-1",
              },
            }).then((r: any) => {
              if (r.isConfirmed) { (this as any).isDeleteFunction(reason, true); }
            });
            return;
          }
          Swal.fire({
              text: response.data?.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Trở lại",
              customClass: {
                  confirmButton: "btn btn-primary",
              },
          }).then(() => {
              Swal.close()
          });  
        });
      
    },
    
    async callSyncCRM() {

      let urlApi = `/admission/student/crm/sync`
      let method = 'post'
      let tempData = {
        student: this.dataCustomer,
        // scholarshipregister: scholarshipregister
      } as any
      // Tóm tắt thông tin sẽ đẩy lên Salesforce để người dùng kiểm tra trước khi đồng bộ
      const c: any = this.dataCustomer || {}
      const esc = (v: any) => String(v ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      // Các trường khớp với ánh xạ Lead/Opportunity ở backend (_sync_CRMLead → upsertLead_CRM):
      // fullName→First/LastName, phone→MobilePhone, email, idCard, class12School→Current_School__c,
      // class12Province→Province__c, prAddress/prWard/prProvince→địa chỉ Scholarship. (SBD/MSSV KHÔNG đẩy lên SF.)
      // dataCustomer lấy từ GET /admission/student/:id (findByIdStudentIncludeDetail, raw) → có key dạng "class12School.name".
      const addressParts = [c.prAddress, c['prWard.name'], c['prDistrict.name'], c['prProvince.name']].filter(Boolean)
      const syncRows = [
        ['Họ tên', c.fullName],
        ['CCCD/CMND', c.idCard],
        ['Số điện thoại', c.phone],
        ['Email', c.email],
        ['Trường THPT (lớp 12)', c['class12School.name']],
        ['Tỉnh/TP (lớp 12)', c['class12Province.name']],
        ['Địa chỉ thường trú', addressParts.join(', ')],
      ].filter((r) => r[1])
      const syncHtml = `
        <div class="text-start">
          <div class="text-muted fs-7 mb-3">Đẩy thông tin hiện tại của ứng viên này lên <span class="fw-semibold">Salesforce</span> (Lead/Opportunity):</div>
          <div class="d-flex flex-column">
            ${syncRows.map(([label, value]) => `
              <div class="d-flex justify-content-between align-items-start py-2 border-bottom border-gray-200 gap-3">
                <span class="text-gray-600 fs-7 flex-shrink-0">${esc(label)}</span>
                <span class="fw-semibold text-gray-900 fs-7 text-end">${esc(value)}</span>
              </div>`).join('')}
          </div>
        </div>`
      Swal.fire({
        title: 'Đồng bộ sinh viên lên Salesforce?',
        html: syncHtml,
        icon: 'warning',
        width: 480,
        customClass: { popup: 'sync-crm-popup' },
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Đồng bộ',
        cancelButtonText: 'Hủy'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.popupLoading()
          await axios[method](`${urlApi}`, tempData)
          .then(( {data} ) => {
            if(data.errors && data.errors.length != 0) {
              Swal.fire({
                  text: data.errors.join(','),
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Làm mới lại trang",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  location.reload()
              }); 
            }
            else {
              this.dataCustomer.issynccrm = true
              Swal.fire({
                  text: "Đồng bộ thành công",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Trở lại",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  // location.reload()
                  this.dataCustomer.opportunityid = data.student?.opportunityid
                  this.dataCustomer.leadid = data.student?.leadid

                  // hideModal(addCustomerModalRef.value);
              });  
            }
                        
          })
          .catch((response) => {
              Swal.fire({
                  text: response.data?.errorMessage || "Có lỗi trong quá trình thực hiện.",
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Làm mới lại trang",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  location.reload()
              });  
            });
        }
      })
          },
    async syncWithIDDoc(data: any) {
      
      let urlApi = `/admission/student/${this.dataCustomer.id}`
      let method = 'put'
      let tempData = {
        dateOfBirth: new Date(data.dateOfBirth),
        idCard: data.idCard,
        fullName: data.fullName
      } as any
      await axios[method](`${urlApi}`, tempData)
          .then(( {data} ) => {
            if(tempData.id) {
              axios.post(`/admission/register/generate/${tempData.id}`)
            }
            this.dataCustomer.fullName = data.fullName
            this.dataCustomer.idCard = data.idCard
            this.dataCustomer.dateOfBirth = data.dateOfBirth
            // this.idCardOld = data.idCard
            // emitter.emit("resetIdDoc");

            Swal.fire({
                text: "Lưu thành công",
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
            }).then(() => {
                // hideModal(addCustomerModalRef.value);
            });              
          })
          .catch(({ response }) => {
              Swal.fire({
                  text: response.data?.errorMessage || "Có lỗi trong quá trình thực hiện.",
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Làm mới lại trang",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  location.reload()
              });  
            });
    },
    async chooseMajorFunction(admissionwinnerid = undefined) {
      this.popupLoading()
      await axios.post(`/admission/bc/create/customer/${this.route.params.id}?admissionwinnerid=${admissionwinnerid}`)
        .then(({ data }) => {
          this.popupSyncRowComplete(data)
        })
        .catch(({ response }) => {
          Swal.fire({
            html: response.data?.message,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: "Đóng",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            }).then(() => {
              Swal.close()
            },300);
        });
      
    },
    
    async changeStatusGraduated() {
      if (!this.isChangeStatusGraduated) {
        this.isChangeStatusGraduated = true
        this.statusGraduated?.focus()
      }
      else {
        let data = {
          highschoolGraduation: this.dataCustomer.highschoolGraduation,
          // verifiedDate: this.dataCustomer.highschoolGraduation !='not_graduated'?this.dataCustomer.verifiedDate:undefined
        }
        await axios.put(`/admission/student/${this.route.params.id}`, data)
          .then(({ data }) => {
            this.submithighschoolGraduation = this.dataCustomer.highschoolGraduation
            this.isChangeStatusGraduated = false
            this.isHighschool = false
          })
          .catch(({ response }) => {
          });
      }
    },
    cancelStatusGraduated() {
      this.dataCustomer.highschoolGraduation = this.submithighschoolGraduation
      this.isChangeStatusGraduated = false
    },
    async changeStatus() {
      if (!this.isChangeStatus) {
        this.isChangeStatus = true
        this.selectStatus?.focus()
      }
      else {
        let data = {
          status: this.dataCustomer.status
        }
        await axios.put(`/admission/student/${this.route.params.id}`, data)
          .then(({ data }) => {
            this.isChangeStatus = false
          })
          .catch(({ response }) => {
          });
      }
    },
    async changeEditAdmissionStudent(result) {
      this.isEdit = false
      if (result.isCanceled) {
        await this.getData(this.route.params.id)
      }
    },
    // Lưu/Hủy từ nút header tab (thay chỗ nút Chỉnh sửa khi đang edit)
    // LƯU Ý QUAN TRỌNG: 2 tab (Cá nhân / Học tập) mỗi tab giữ MỘT BẢN SAO ĐẦY ĐỦ của hồ sơ và khi lưu
    // thì PUT NGUYÊN BẢN lên /admission/student/:id. Nếu chỉ submit tab đang mở thì bản sao đó sẽ ghi đè
    // luôn các field của tab kia bằng giá trị CŨ -> mất sửa đổi tab kia (sửa Cá nhân rồi lưu ở Học tập
    // thì mất phần Cá nhân, và ngược lại thì mất điểm).
    // -> Trộn phần ĐÃ SỬA của tab kia vào tab sắp submit, rồi submit MỘT lần duy nhất.
    // Trộn sửa đổi của tab KIA vào tab sắp submit. Dùng chung cho CẢ 2 đường lưu:
    //  - nút Lưu ở header  -> saveEditTab()
    //  - nút Lưu trong form -> component emit 'beforeSave' (vì nó gọi thẳng submit(), không qua saveEditTab)
    mergeBeforeSave(target) {
      const p = this.$refs.personalInfor as any
      const l = this.$refs.learningInfor as any
      // Cho mỗi tab tự suy các field dẫn xuất (mã/tên tỉnh-xã, tên trường) TRƯỚC khi trộn
      p?.applyDerived?.()
      l?.applyDerived?.()
      const base: any = this.dataCustomer || {}
      // Chỉ lấy field THỰC SỰ khác bản gốc -> không kéo theo giá trị cũ đè lên tab kia
      const diffOf = (fd: any) => {
        const d: any = {}
        if (!fd) return d
        Object.keys(fd).forEach((k) => {
          if (JSON.stringify(fd[k]) !== JSON.stringify(base[k])) d[k] = fd[k]
        })
        return d
      }
      if (target === 'learning') {
        if (l?.formData && p?.formData) Object.assign(l.formData, diffOf(p.formData))
      } else {
        if (p?.formData && l?.formData) Object.assign(p.formData, diffOf(l.formData))
      }
    },
    saveEditTab() {
      const target = this.activeTabKey === 'learning' ? 'learning' : 'personal'
      this.mergeBeforeSave(target)
      if (target === 'learning') (this.$refs.learningInfor as any)?.submit()
      else (this.$refs.personalInfor as any)?.submit()
    },
    cancelEditTab() {
      if (this.activeTabKey === 'learning') (this.$refs.learningInfor as any)?.loadDefaultData()
      else (this.$refs.personalInfor as any)?.loadDefaultData()
    },
    isEditFunction() {
      this.isEdit = true
    },
    // Fix trường hợp đã có mã SV nhưng AdmApplicant (SIS) chưa được tạo
    async fixSyncAdmApplicant() {
      if (!this.dataCustomer.studentcode) {
        Swal.fire({
          text: "Ứng viên chưa có mã SV. Vui lòng tạo mã SV trước.",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "Đóng",
          customClass: { confirmButton: "btn btn-primary" },
        })
        return
      }
      Swal.fire({
        text: `Đồng bộ (tạo/cập nhật) AdmApplicant trên SIS cho mã SV ${this.dataCustomer.studentcode}?`,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Trở lại",
        customClass: {
          confirmButton: "btn btn-primary order-2",
          cancelButton: "btn btn-light order-1",
        },
      }).then(async (result) => {
        if (!result.isConfirmed) return
        this.popupLoading()
        await axios.post(`/admission/sis/upsert/admapplicant/${this.route.params.id}`)
          .then(({ data }) => {
            Swal.fire({
              text: "Đã đồng bộ AdmApplicant (SIS) thành công",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Đóng",
              customClass: { confirmButton: "btn btn-primary" },
            }).then(() => { Swal.close() }, 300)
          })
          .catch(({ response }) => {
            Swal.fire({
              html: response?.data?.message || response?.data?.errorMessage || "Có lỗi trong quá trình đồng bộ SIS.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Đóng",
              customClass: { confirmButton: "btn btn-primary" },
            }).then(() => { Swal.close() }, 300)
          })
      })
    },
    getCookie(name: string): string | null {
      const nameLenPlus = (name.length + 1);
      return document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
          return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map(cookie => {
          return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
    },
    async getData(id) {
      await axios.get(`/admission/student/${id}`)
        .then(({ data }) => {
          data.updatedAt = moment(data.updatedAt).format('DD/MM/YYYY HH:mm')
          data.createdAt = moment(data.createdAt).format('DD/MM/YYYY HH:mm')
          this.dataCustomer = data as any
          this.submithighschoolGraduation = this.dataCustomer.highschoolGraduation
          this.passwordStudent = data.accessCode
          // Cảnh báo CCCD TRÙNG: có ứng viên KHÁC cùng CMND/CCCD -> hiện cảnh báo (không chặn lưu)
          this.idCardDuplicate = []
          if (data.idCard) {
            axios.post('/admission/student/idcardcount', { idCard: data.idCard })
              .then(({ data: c }) => {
                this.idCardDuplicate = (c.student || []).filter((s: any) => s.id !== data.id)
              }).catch(() => {})
          }
        })
        .catch(({ response }) => {
          // 403 = hồ sơ không thuộc phụ trách (chốt BE 2026-07) -> báo NHẸ rồi quay lại, không hiện trang lỗi
          if (response?.status === 403) {
            Swal.fire({
              text: response?.data?.errorMessage || 'Hồ sơ này không thuộc phụ trách của bạn.',
              icon: 'info',
              timer: 2600,
              timerProgressBar: true,
              buttonsStyling: false,
              showConfirmButton: false,
            })
            this.router.back()
          }
        });
    },
    async getAdmission(id) {
      await axios.get(`/admission/register/student/${id}`)
        .then(({ data }) => {
          this.dataAdmission = [] as any
          data.forEach(item => {
            let temp = {
              id: item.id,
              date: moment(item.createdAt).format('DD/MM/YYYY'),
              updatedAt: item.updatedAt ? moment(item.updatedAt).format('DD/MM/YYYY') : '',
              code: item.profileCode,
              method: item.adMethodName,
              idAdMethod: item.idAdMethod,
              status: {
                label: this.statusTag[item.isPassed == null ? item.status : item.isPassed ? 'passed' : 'failed']?.label,
                state: this.statusTag[item.isPassed == null ? item.status : item.isPassed ? 'passed' : 'failed']?.state,
                value: item.isPassed == null ? item.status : item.isPassed ? 'passed' : 'failed',
              },
              //số QĐ + id winner đang hiệu lực (BE gắn, loại revoked) — decision null = trúng TẠM chờ cấp QĐ
              //(badge phụ + kebab "Cấp QĐ trúng tuyển"/"Thu hồi QĐ trúng tuyển" ở AdmissionProfile dựa 2 cờ này)
              winnerDecisionCode: item.winnerDecisionCode,
              winnerId: item.winnerId,
              phase: item.phase,
              isActive: item.isActive,
              isAppraised: item.isArchived ? item.isArchived : item.isAppraised,
              action: true,
              source: item.source,
              majors: item.majors.sort((a, b) => {
                if (a.priority !== undefined && b.priority !== undefined) {
                  return a.priority > b.priority ? 1 : -1;
                } else {
                  return a.priority !== undefined ? 1 : -1
                }
              }),
              adCode: item.adCode,
            }
            this.dataAdmission.push(temp)
          })
          // console.log('dataAdmission', this.dataAdmission)
        })
        .catch(({ response }) => {
        });
      await axios.get(`/applicant/student/${id}`)
        .then(({ data }) => {
          this.dataApplicant = []
          const statusNone = data.filter(e=>{
            if(e.status != 'none'){
              return e
            }
          })
          if(statusNone.length>0){
            data.forEach(item => {
              let temp = {
                createdAt: moment(item.createdAt).format('DD/MM/YYYY'),
                id: item.id,
                applicantId: item.applicantId, //id hồ sơ nhập học (applicant) — link đúng, KHÁC item.id (winner id)
                profileCode: item.profileCode,
                phase: item.phase,
                major: item.adMajor,
                majorCode: item.adMajorCode,
                status: item.status,
                applicantStatus: item.applicantStatus,
                applicantStudentCode: item.applicantStudentCode, //MSSV lấy từ APPLICANT (có thể cấp riêng trước khi xác nhận) — dùng để mở nút In phiếu
                idAdMethod: item.idAdMethod,
                //AdmissionWinner đặt tên cột là idStudent (KHÔNG phải studentId) -> lấy sai thì row
                //không có id ứng viên (banner "hủy nhầm" ở tab Hồ sơ nhập học im lặng không hiện)
                studentId: item.idStudent || item.studentId,
                studentcode: item.studentcode,
              }
              this.dataApplicant.push(temp)
            })
          }
        })
        .catch(({ response }) => {
        });
    },
    // Học bổng của ứng viên (đăng ký + cấp) — chỉ hiện tab nếu có
    async getScholarship(idStudent) {
      if (!idStudent) return
      await axios.post(`/scholarshipregisters/find/registered`, { studentId: idStudent })
        .then(({ data }) => { this.scholarshipList = Array.isArray(data) ? data : (data?.items || []) })
        .catch(() => { this.scholarshipList = [] })
    },
    // Mở drawer xem/sửa 1 đăng ký học bổng của ứng viên (mode edit — drawer tự khoá khi đã duyệt/từ chối)
    openScholarshipDrawer(s) {
      (this.$refs.scholarshipRegisterDrawer as any)?.open(s.id, 'edit')
    },
    // Xóa đăng ký học bổng sai — nút chỉ hiện khi Chờ cấp; BE cũng chặn status != 'new'
    async deleteScholarshipReg(s) {
      const name = s.regScholarshipName ? `${s.regScholarshipName}${s.regScholarshipCode ? ` (${s.regScholarshipCode})` : ''}` : 'đăng ký này'
      const { isConfirmed } = await Swal.fire({
        html: `Xóa đăng ký học bổng <b>${name}</b>?<br/>Thao tác này không thể hoàn tác.`,
        icon: 'warning', showCancelButton: true, buttonsStyling: false,
        confirmButtonText: 'Xóa', cancelButtonText: 'Hủy',
        customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-light' },
      })
      if (!isConfirmed) return
      await axios.delete(`/scholarshipregisters/${s.id}`)
        .then(() => {
          Swal.fire({ text: 'Đã xóa đăng ký học bổng!', icon: 'success', timer: 1800, timerProgressBar: true, showConfirmButton: false, buttonsStyling: false })
          this.getScholarship(this.route.params.id)
        })
        .catch(({ response }) => {
          Swal.fire({
            text: String(response?.data?.errorMessage || '').replace(/^Validation error:\s*/i, '') || 'Không xóa được, vui lòng thử lại.',
            icon: 'error', buttonsStyling: false, confirmButtonText: 'Đóng', customClass: { confirmButton: 'btn btn-primary' },
          })
        })
    },
    // Phê duyệt TẠI CHỖ: mở modal duyệt (component chung với trang Duyệt học bổng) theo id đăng ký —
    // component tự fetch register + ngành ứng viên; @saved -> refresh bảng học bổng
    gotoApproveScholarship(s) {
      (this.$refs.scholarshipApproveModal as any)?.open(s.id)
    },
    scholarshipStatusBadge(status) {
      const m = { new: ['warning', 'Chờ cấp'], pending: ['info', 'Chờ phê duyệt'], approved: ['success', 'Đã phê duyệt'], rejected: ['danger', 'Đã từ chối'] }
      return m[status] || ['secondary', status || '—']
    },
    fmtScholarshipDate(d) {
      if (!d) return ''
      try { return new Date(d).toLocaleDateString('vi-VN') } catch (e) { return d }
    },
    schGrant(s) {
      return (s && s.ScholarshipStudents && s.ScholarshipStudents[0]) || {}
    },
    fmtMoney(v) {
      if (v == null || v === '') return ''
      const n = Number(v)
      return isNaN(n) ? v : n.toLocaleString('vi-VN')
    },
  },
  async created() {
    await this.getData(this.route.params.id)
    await this.getAdmission(this.route.params.id)
    this.getScholarship(this.route.params.id)
    // Link cũ ?addProfile=1 (từ trang Thêm ứng viên) → chuyển thẳng sang TRANG Thêm hồ sơ
    if (this.route.query.addProfile) {
      this.router.replace(`/themhoso/${this.route.params.id}`)
      return
    }
    // TAB MẶC ĐỊNH = "Thông tin học tập" (đặt trước + active sẵn trong HTML -> KHÔNG auto-click, hết nháy load).
    // Chỉ click sang tab khác cho các trường hợp đặc biệt (nextTick để ref tab đã mount):
    // - #tab3 -> Hồ sơ đăng ký xét
    // - ?tab=personal (link cảnh báo trùng CCCD) -> Thông tin cá nhân
    this.$nextTick(() => {
      if (this.route.hash == '#tab3') {
        this.click_view_admission_profile?.click()
      } else if (this.route.query.tab === 'personal') {
        this.click_view_personal_infor?.click()
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    })
  },
  async mounted() {
    const temp = window.localStorage.getItem("user")
    this.infUser = temp?JSON.parse(temp) : {} as any
    // emitter.on("resetIdDoc", async () => {
    //   this.IDDoc = null
    // })
    // Gỡ handler cũ trước khi đăng ký lại — tránh tích lũy listener qua mỗi lần điều hướng
    // (handler cũ trỏ vào instance đã unmount → callFunctionModalRunAnalysis = null → crash)
    emitter.off("openCccdScan")
    emitter.on("openCccdScan", () => {
      // Nút quét CCCD bên cạnh ô CMND/CCCD (PersonalInfor) → mở modal Phân tích AI
      this.runAnalysis()
    })
    emitter.off("updateApplicantData")
    emitter.on("updateApplicantData", async () => {
      await axios.get(`/applicant/student/${this.route.params.id}`)
        .then(({ data }) => {
          this.dataApplicant = []
          const statusNone = data.filter(e=>{
            if(e.status != 'none'){
              return e
            }
          })
          if(statusNone.length>0){
            data.forEach(item => {
              let temp = {
                createdAt: moment(item.createdAt).format('DD/MM/YYYY'),
                id: item.id,
                applicantId: item.applicantId, //id hồ sơ nhập học (applicant) — link đúng, KHÁC item.id (winner id)
                profileCode: item.profileCode,
                phase: item.phase,
                major: item.adMajor,
                status: item.status,
                applicantStatus: item.applicantStatus,
                applicantStudentCode: item.applicantStudentCode, //MSSV lấy từ APPLICANT (có thể cấp riêng trước khi xác nhận) — dùng để mở nút In phiếu
                idAdMethod: item.idAdMethod,
                //AdmissionWinner đặt tên cột là idStudent (KHÔNG phải studentId) -> lấy sai thì row
                //không có id ứng viên (banner "hủy nhầm" ở tab Hồ sơ nhập học im lặng không hiện)
                studentId: item.idStudent || item.studentId,
                studentcode: item.studentcode,
              }
              this.dataApplicant.push(temp)
            })
          }
        })
        .catch(({ response }) => {
        });
        
    });
  },
  setup() {
    function popupLoading() {
       Swal.fire({
        html:"<div class='custom-loading'><span>Đang xử lý. Vui lòng chờ trong giây lát!!!</span> <span class='loader'></span></div>",
        buttonsStyling: false,
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
      }).then(() => {
        //
      });
    }
    const route = useRoute();
    const router = useRouter();
    // const IDDoc = ref<any>(null)
    // const key = 'GI2jauw2Zdl1x1NGou8SBy20OkosgRFqJgn3Bt64GWRJdqHXzo3iJQQJ99AKACYeBjFXJ3w3AAALACOGBRUt'
    // const credential = new AzureKeyCredential(key);
    // const client = new DocumentAnalysisClient(
    //   "https://umtdocumentintelligence.cognitiveservices.azure.com/",
    //   credential
    // );
    const infUser = ref<any>(undefined)
    const isEdit = ref(false)
    const crmField = ref<any>('')
    const selectStatus = ref<null | HTMLFormElement>(null);
    const statusGraduated = ref<null | HTMLFormElement>(null);
    const click_view_admission_profile = ref<null | HTMLFormElement>(null);
    const click_view_learning_infor = ref<null | HTMLFormElement>(null);
    const click_view_personal_infor = ref<null | HTMLFormElement>(null);
    const callFunctionModal = ref<any>();
    const callFunctionEditField = ref<any>();
      
    const callFunctionModalChooseMajor = ref<any>();
    const callFunctionModalRunAnalysis = ref<any>();
    const callFunctionModalChooseApplicants = ref<any>();
      
      

    const dataCustomer = ref<Form>({
      status: "" as any,
      fullName: "",
      gender: "",
      birthPlace: "",
      dateOfBirth: "",
      phone: "",
      idCard: "",
      email: "",
      contactAddress: "",
      contactProvinceId: "",
      contactDistrictId: "",
      contactWardId: "",
      prProvinceId: "",
      prDistrictId: "",
      prWardId: "",
      prAddress: "",
      class10ProvinceId: "",
      class10DistrictId: "",
      class10SchoolId: "",
      class11ProvinceId: "",
      class11DistrictId: "",
      class11SchoolId: "",
      class12ProvinceId: "",
      class12DistrictId: "",
      class12SchoolId: "",
      graduatedYear: "",
      priorityObject: "00",
      priorityArea: "",
      priorityScore: 0,
      highschoolGraduation: "",
      verifiedDate: "",
      orderNumber: "",
      studentcode:"",
    });
    const dataAdmission = ref<any>([] as any)
    // Ứng viên CHỈ có hồ sơ liên thông (mọi hồ sơ đều idAdMethod=9).
    // KHÔNG dùng để ẩn tab "Thông tin học tập" (thí sinh LT vẫn phải khai lớp 12 + số hiệu bằng THPT)
    // mà chỉ để ẩn 2 bảng điểm THPT bên trong tab — chúng chỉ phục vụ PT1/PT2 hệ chính quy.
    const isOnlyArticulation = computed(() => dataAdmission.value.length > 0 && dataAdmission.value.every((h: any) => h.idAdMethod == 9))
    // Ứng viên đã CÓ ít nhất 1 hồ sơ liên thông -> chặn tạo hồ sơ LT thứ 2 (mỗi ứng viên chỉ 1 hồ sơ LT;
    // khối "Bằng TC/CĐ" ở tab học tập chỉ hiển thị 1 _arpros, có 2 sẽ nhập nhằng). .some khác isOnlyArticulation (.every).
    const hasArticulation = computed(() => dataAdmission.value.some((h: any) => h.idAdMethod == 9))
    // Chặn XÓA ứng viên khi đã vào luồng xét tuyển. Khớp guard BE (updateIsDelete_Students):
    // đã thẩm định (isAppraised — FE gộp cả isArchived) hoặc đã có kết quả (status.value passed/failed).
    // Xóa mềm ở các trạng thái này để lại winner mồ côi / thủng danh sách trúng tuyển.
    const deleteBlockedText = computed(() => {
      const _blocked = (dataAdmission.value as any[]).filter((h: any) =>
        h?.isAppraised === true || h?.status?.value === 'passed' || h?.status?.value === 'failed')
      if (_blocked.length === 0) return ''
      const _codes = _blocked.map((h: any) => h.code).filter(Boolean).join(', ')
      return `Không thể xóa: ứng viên có hồ sơ đang/đã xét trúng tuyển (đã thẩm định hoặc đã có kết quả)${_codes ? ' — ' + _codes : ''}.`
    })
    const idCardDuplicate = ref([] as any[])  // ứng viên KHÁC cùng CMND/CCCD -> cảnh báo trùng
    const dataApplicant = ref<Array<DataApplicant>>([])
    const chooseMajor = ref<any>([])
    const statusTag = ref({
      "new": {
        label: "Mới",
        state: "primary",
        icon: 'new',
      },

      "processing": {
        label: "Chưa hoàn tất",
        state: "warning",
        icon: '/media/icons/duotune/general/gen044.svg',
      },
      "verified": {
        label: "Đã xác thực",
        state: "success",
        icon: '/media/icons/duotune/general/gen026.svg',
      },
      "reviewing": {
        label: "Đang xem xét",
        state: "info",
        icon: '/media/icons/duotune/general/gen026.svg',
      },
      "rejected": {
        label: "Không hợp lệ",
        state: "danger",
        icon: "/media/icons/duotune/arrows/arr015.svg",
      },
      "denied": {
        label: "Từ chối",
        state: "danger",
        icon: "/media/icons/duotune/arrows/arr015.svg",
      },
      
      "passed": {
        label: "Đã trúng tuyển",
        state: "success",
      },
      "failed": {
        label: "Đã trượt",
        state: "danger",
      },
    })
    
    return {
      dataCustomer,
      dataAdmission,
      isOnlyArticulation,
      hasArticulation,
      deleteBlockedText,
      idCardDuplicate,
      dataApplicant,
      statusTag,
      isEdit,
      selectStatus,
      statusGraduated,
      Permission,
      callFunctionModal,
      callFunctionEditField,
      callFunctionModalChooseMajor,
      callFunctionModalRunAnalysis,
      click_view_admission_profile,
      click_view_learning_infor,
      click_view_personal_infor,
      callFunctionModalChooseApplicants,
      chooseMajor,
      infUser,
      route,
      router,
      crmField,
      // client,
      // IDDoc,
      popupLoading
    };
  },
});
